import type { CommandName } from '../../commands/command-name.enum';

/**
 * Builds a route `enter` guard for a privilege (feature plan 0054). Pure and dependency-injected —
 * the privilege check and the navigation are passed in — because routes.ts itself cannot be
 * imported under vitest (it drags in the whole app graph, see route-filters.ts).
 *
 * Pass the typed `hasPrivilege()` check, NOT a raw privileges-array `includes`: an empty
 * privileges array means admin, which a raw includes() would lock out. Soft today while
 * authorization is disabled (hasPrivilege returns true for all).
 */
export const requirePrivilege = (
    privilege: CommandName,
    check: (privilege: CommandName) => boolean,
    goto: (path: string) => void,
): (() => boolean) => () => {
    if (!check(privilege)) {
        goto('/');
        return false;
    }

    return true;
};
